module.exports = __webpack_public_path__ + "static/img/Symphony-Default.fb76007.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Symphony-Default.png
// module id = 1596
// module chunks = 0